module.exports = __webpack_public_path__ + "static/media/moisture.0bd7f068.svg";